interface props {
  className?: string;
  children: React.ReactNode;
}
export default function GradientText({ className,children }: props) {
  return (
    <b className={`text-transparent text-gradient selection:text-blue-800 selection:bg-blue-100 bg-clip-text bg-gradient bg-gradient-to-r dark:from-blue-400 dark:to-purple-600 from-blue-400 to-purple-300 ${className}`}>
      {children}
    </b>
  );
}
